export const LOGIN_LINK_ENDPOINTS = {
  REQUEST: '/auth/link/request',
  VALIDATE: '/auth/link/validate',
} as const;
